'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' });

var Brightness5 = function Brightness5(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Brightness5 = (0, _pure2.default)(Brightness5);
Brightness5.muiName = 'SvgIcon';

exports.default = Brightness5;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Brightness5.js
// module id = 2198
// module chunks = 0